<div class="card-view detail-stl detail-view-stl" *ngIf="detail_view_product">
  <div class="card__stl card" style="border: 1px solid #dcdcdc">
    <div class="card-header card-header-stl">
      {{ detail_view_product["S_NO"] }}.
      {{ detail_view_product["activeIngredient"] }}
    </div>
    <div class="card-body p-0">
      <!-- ===== IMAGE SECTION ON TOP ===== -->
      <div class="d-flex justify-content-center flex-wrap w-100 p-3 border-bottom" *ngIf="hasImageFields()">
        <ng-container *ngFor="let template_col of getImageCols()">
          <ng-container *ngFor="let value of getFieldValues(template_col.field)">
            <div class="imageBoxSecond mb-2">
              <img
                class="logo-stl"
                [src]="getImageUrl(template_col, value)"
                alt=""
                width="40%"
                class="mr-2"
              />
              <button
                class="imageBoxSecond_viewImage"
                (click)="ImageFullView(template_col, value)"
              >
                <img
                  src="../../../../../assets/icons/view-icon.png"
                  alt="View"
                />
                View
              </button>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <div class="d-flex align-content-stretch flex-wrap mb-3">
        <ng-container *ngFor="let template_col of cols; let i = index">
          <div
            class="col-12 my-2"
            *ngIf="showMoreButton && showMoreButtonIndex === i"
          >
            <div class="row justify-content-center">
              <button
                type="button"
                class="more_btn"
                *ngIf="!showMore"
                (click)="showMore = true"
              >
                More
              </button>
              <button
                type="button"
                class="less_btn"
                *ngIf="showMore"
                (click)="showMore = false"
              >
                Less
              </button>
            </div>
          </div>
          
          <ng-container *ngIf="template_col && template_col.fieldDataType !== 'image'">
            <!-- ===== SHOW FIELDS FROM gbrn_products (aggregated) ===== -->
            <ng-container
              *ngIf="
                hasFieldData(template_col.field) &&
                (showMore || showMoreButtonIndex < 0
                  ? true
                  : i < showMoreButtonIndex)
              "
            >
              <div class="col-6 p-2">
                <div class="card p-0 h-100" style="border: none">
                  <div
                    class="card-header card-header-stl-2 p-2 pb-0"
                    style="
                      font-size: 16px;
                      font-weight: 600;
                      background-color: #ffffff;
                      border: none;
                      text-decoration: none;
                    "
                  >
                    {{ template_col.displayColumnName }}
                  </div>
                  <div class="card-body p-2 pt-0">
                    <!-- TEXT AND DATE FIELDS -->
                    <ng-container *ngIf="template_col.fieldDataType == 'text' || template_col.fieldDataType == 'date'">
                      <ng-container *ngFor="let value of getFieldValues(template_col.field); let idx = index">
                        <span *ngIf="idx > 0">, </span>
                        <span
                          appHighlight
                          [searchedWords]="searchedWords"
                          [text]="addDataSpace(value)"
                          classToApply="highlight__keyword_1"
                        ></span>
                      </ng-container>
                    </ng-container>

                    <!-- DOCUMENT FIELDS -->
                    <ng-container *ngIf="template_col.fieldDataType == 'document'">
                      <ng-container *ngFor="let value of getFieldValues(template_col.field)">
                        <a
                          target="_blank"
                          [href]="
                            'https://chemrobotics.com/agropat/' +
                            imageBaseUrls[template_col.field] +
                            value
                          "
                          class="btn btn-sm btn-primary mb-2"
                          type="button"
                          style="display: block; width: fit-content;"
                          ><i class="fa fa-download"></i>
                          {{ addDataSpace(value) }}</a
                        >
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- For Image view -->
<p-galleria
  [value]="images"
  [(visible)]="displayBasic"
  [responsiveOptions]="responsiveOptions"
  [containerStyle]="{ 'max-width': '850px' }"
  [numVisible]="7"
  [circular]="true"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [showThumbnails]="false"
>
  <ng-template pTemplate="item" let-item>
    <div class="image-wrapper" style="background-color: #fff">
      <button class="image-close-button" (click)="onCloseGalleria()">✖</button>
      <img [src]="item.itemImageSrc" style="width: 100%; display: block" />
    </div>
  </ng-template>
</p-galleria>